<iframe
    [src]="domSanitizer.bypassSecurityTrustResourceUrl(baseUrl + query)"
    width="100%"
    height="300"
    style="border:0;"
    allowfullscreen=""
    loading="lazy"
    referrerpolicy="no-referrer-when-downgrade"
></iframe>
